import { createReducer, on } from '@ngrx/store';

import type { Intervention } from '../../models/intervention';
import { InterventionActions } from '../actions/interventions';

export type InterventionsState = Record<string, Intervention>;

export const INTERVENTIONS_INITIAL_STATE: InterventionsState = {};

export default createReducer(
    INTERVENTIONS_INITIAL_STATE,
    on(InterventionActions.siteInterventionsLoaded, (state, { interventions }): InterventionsState => {
        return interventions.reduce((acc, intervention) => {
            return { ...acc, [intervention.id]: { ...intervention } };
        }, {});
    }),

    on(InterventionActions.interventionRequestSubmitted, (state, intervention: Intervention): InterventionsState => {
        return { ...state, [intervention.id]: { ...intervention } };
    }),

    on(InterventionActions.updateSiteIntervention, (state, { intervention }): InterventionsState => {
        return { ...state, [intervention.id]: { ...intervention } };
    }),

    on(InterventionActions.accessGrantedIntervention, (state, { sessionId }): InterventionsState => {
        const updated = { ...state };
        const interventions = Object.values(updated).filter((i) => i.sessionId === sessionId);
        if (interventions.length === 0) {
            return state;
        }
        interventions.forEach((intervention) => {
            updated[intervention.id] = { ...intervention, accessGranted: true };
        });
        return updated;
    }),
);
